function numberCounter() {
    var dataId = $('.number-counter').attr('data-section-id');

    $('.inview-' + dataId + '-initialized').bind('inview', function(event, visible) {
        if (visible) {
            $('.number-counter-value').each(function() {
                var $this = $(this);
                var max_value = parseFloat($this.attr('data-value'));
                var isDecimal = (max_value % 1 !== 0);
                var startValue = parseFloat($this.attr('data-start') || 0);

                // Reiniciar al valor inicial antes de animar
                $this.text(isDecimal ? startValue.toFixed(1) : Math.floor(startValue));

                // Crear objeto aislado por elemento para evitar conflicto de closures
                var animObj = { counter_value: startValue };

                $(animObj).animate({
                    counter_value: max_value
                }, {
                    step: function() {
                        if (isDecimal) {
                            $this.text(this.counter_value.toFixed(1));
                        } else {
                            $this.text(Math.floor(this.counter_value));
                        }
                    },
                    duration: 1500,
                    easing: 'swing',
                    complete: function() {
                        if (isDecimal) {
                            $this.text(max_value.toFixed(1));
                        } else {
                            $this.text(
                                Math.round(this.counter_value)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            );
                        }
                    }
                });
            });
        }
    });
}

$(document).ready(function() {
    numberCounter();
});